<section class="relative min-h-full min-w-full">
  <button (click)="dialogRef.close()" class="absolute right-5 top-5 z-10 cursor-pointer text-white" type="button">
    <app-svg [inline]="true" [width]="15" src="assets/icons/close.svg" />
  </button>
  <div (click)="dialogRef.close()" class="absolute inset-0 cursor-zoom-out bg-black/50">
    <div class="absolute inset-0 px-5 pb-5 pt-20">
      <div class="relative size-full">
        @if (data.image; as image) {
          <app-image [image]="image" [isPriority]="true" [keepAspectRatio]="true" />
        }
      </div>
    </div>
  </div>
</section>
